import { __decorate } from "tslib";
import InstructorsTableBase from '@/classes/InstructorsTableBase';
import Component from "vue-class-component";
import { Prop } from 'vue-property-decorator';
import { SERVICE_TYPE } from '@/constants/ServiceTypes';
import InstructorTableAvailableCell from '@/classes/InstructorTableAvailableCell';
import { InstructorTableRowType } from '@/enums/InstructorTableRowType';
import Snackbar from './Snackbar.vue';
import ConfirmDialog from './ConfirmDialog.vue';
import { NotificationTypes } from "@/enums/NotificationTypes";
import _ from 'lodash';
import { shortenString } from "@/plugins/helpers";
import ServiceIcon from "@/components/ServiceIcon.vue";
import { isDesktop } from '@/utils/isDesktop';
let InstructorsTableReservedCell = class InstructorsTableReservedCell extends InstructorsTableBase {
    dataSource;
    rowData;
    cellData;
    voucherDialog = false;
    voucherCode = '';
    processingVoucher = false;
    voucherErrors = [];
    togglingPrepaid = false;
    dialog = false;
    async useVoucher() {
        this.processingVoucher = true;
        try {
            const voucher = this.$store.getters['voucher/all']
                .find((voucher) => voucher.data.code === this.voucherCode);
            if (!voucher) {
                throw new Error('Neplatný kód');
            }
            await this.cellData.useVoucher(voucher);
            await this.updateDataSource();
            this.voucherDialog = false;
            Snackbar.success('Poukaz aplikován!');
        }
        catch (e) {
            console.error(e);
            this.voucherErrors.push(e instanceof Error ? e.message : String(e));
            this.processingVoucher = false;
        }
    }
    async clearVoucher() {
        try {
            await this.cellData.clearVoucher();
            await this.updateDataSource();
            Snackbar.success('Poukaz smazán!');
        }
        catch (e) {
            console.error(e);
            Snackbar.error('Poukaz se nepodařilo smazat!');
        }
    }
    openVoucherDialog() {
        this.processingVoucher = false;
        this.voucherErrors.splice(0, this.voucherErrors.length);
        this.voucherCode = '';
        this.voucherDialog = true;
    }
    get isDesktop() {
        return isDesktop();
    }
    get cellCaptionDesktop() {
        if (this.cellData.length === 1) {
            if (this.cellData.clients.length === 1) {
                return `${shortenString(this.cellData.clients[0].name, 14)} (${this.cellData.clients[0].age})`;
            }
            else if (this.cellData.clients.length > 1 && this.cellData.clients.length < 5) {
                return `${this.cellData.clients.length} klienti`;
            }
            else {
                return `${this.cellData.clients.length} klientů`;
            }
        }
        else {
            if (this.cellData.clients.length === 1) {
                return `${this.cellData.clients[0].name} (${this.cellData.clients[0].age})`;
            }
            else if (this.cellData.clients.length > 1 && this.cellData.clients.length < 5) {
                return `${this.cellData.clients.length} klienti`;
            }
            else {
                return `${this.cellData.clients.length} klientů`;
            }
        }
    }
    get cellCaptionMobile() {
        if (this.cellData.clients.length === 1) {
            const splitName = this.cellData.clients[0].name.split(' ');
            const firstName = splitName[0];
            return `${firstName}<br>(${this.cellData.clients[0].age})`;
        }
        else if (this.cellData.clients.length > 1 && this.cellData.clients.length < 5) {
            return `${this.cellData.clients.length} klienti`;
        }
        else {
            return `${this.cellData.clients.length} klientů`;
        }
    }
    async delete() {
        if (this.rowData.rowType === InstructorTableRowType.INSTRUCTOR) {
            for (let i = 0; i < this.cellData.length; i++) {
                const availableCell = new InstructorTableAvailableCell(this.rowData);
                availableCell.hour = this.cellData.hour + i;
                this.rowData.cells.push(availableCell);
            }
        }
        this.rowData.cells.splice(this.rowData.cells.indexOf(this.cellData), 1);
        await this.updateDataSource();
    }
    async togglePrepaid() {
        this.togglingPrepaid = true;
        if (this.cellData.isPrepaid) {
            if (!await ConfirmDialog.open('Potvrzení', 'Opravdu chcete lekci označit jako nezaplacenou?')) {
                this.togglingPrepaid = false;
                return;
            }
        }
        this.cellData.isPrepaid = !this.cellData.isPrepaid;
        await this.updateDataSource();
        this.togglingPrepaid = false;
    }
    async remove() {
        if (!(await ConfirmDialog.open('Mazání záznamu', 'Opravdu si přejete záznam smazat?'))) {
            return;
        }
        if (this.cellData.voucher !== null) {
            await this.cellData.clearVoucher();
        }
        await this.cellData.notifyInstructor(`Výuka dne ${this.dataSource.date.format('D. M. YYYY')} od ${this.cellData.hour}:00 byla zrušena`, NotificationTypes.WARNING, { name: 'InstructorsTimeScheduleWithDate', params: { date: this.dataSource.date.format('YYYY-MM-DD') } });
        await this.delete();
    }
    async edit() {
        const availableHourCount = this.getAvailableHourCount(this.rowData, this.cellData.hour + this.cellData.length - 1) + this.cellData.length - 1;
        //await this.delete();
        document.dispatchEvent(new CustomEvent('editClient', {
            detail: {
                from: this.getDateTimeWithHours(this.dataSource.date, this.cellData.hour),
                availableHours: availableHourCount,
                row: this.rowData,
                hour: this.cellData.hour,
                cell: this.cellData
            }
        }));
    }
    async storno() {
        this.cellData.service = SERVICE_TYPE.STORNO;
        for (let i = 1; this.cellData.length > i; i++) {
            const availableCell = new InstructorTableAvailableCell(this.rowData);
            availableCell.hour = this.cellData.hour + i;
            this.rowData.cells.push(availableCell);
        }
        this.cellData.length = 1;
        await this.cellData.notifyInstructor(`Výuka dne ${this.dataSource.date.format('D. M. YYYY')} od ${this.cellData.hour}:00 byla stornována`, NotificationTypes.WARNING, { name: 'InstructorsTimeScheduleWithDate', params: { date: this.dataSource.date.format('YYYY-MM-DD') } });
        await this.updateDataSource();
    }
    async cut() {
        if (!(await ConfirmDialog.open('Přesuní záznamu', 'Opravdu si přejete záznam přesunout? Pokud vyjmutý záznam nikam nevložíte, data se ztratí.'))) {
            return;
        }
        await this.cellData.notifyInstructor(`Výuka dne ${this.dataSource.date.format('D. M. YYYY')} od ${this.cellData.hour}:00 byla zrušena`, NotificationTypes.WARNING, { name: 'InstructorsTimeScheduleWithDate', params: { date: this.dataSource.date.format('YYYY-MM-DD') } });
        this.copy(null, true);
        await this.delete();
    }
    copy(event, cut = false) {
        const cellData = _.cloneDeep(this.cellData);
        if (!cut) {
            cellData.isPrepaid = false;
            cellData.voucher = null;
            cellData.voucherBlockedValue = 0;
        }
        this.$store.dispatch('instructorTable/copyCell', cellData.toSaveObject());
        Snackbar.success('Zkopírováno!');
    }
    isInstructorRow() {
        return this.rowData.rowType === InstructorTableRowType.INSTRUCTOR;
    }
};
__decorate([
    Prop({ required: true })
], InstructorsTableReservedCell.prototype, "dataSource", void 0);
__decorate([
    Prop({ required: true })
], InstructorsTableReservedCell.prototype, "rowData", void 0);
__decorate([
    Prop({ required: true })
], InstructorsTableReservedCell.prototype, "cellData", void 0);
InstructorsTableReservedCell = __decorate([
    Component({
        components: { ServiceIcon }
    })
], InstructorsTableReservedCell);
export default InstructorsTableReservedCell;
